import { clusterApiUrl, Connection, PublicKey } from '@solana/web3.js';
import { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import LandingPage from './pages/Landing';
import AboutPage from './pages/About';
import VotingPage from './pages/Voting';

function App() {
	const [bal, setBal] = useState(0);
	const getBal = async () => {
		console.log('hello');
		const connection = new Connection(clusterApiUrl('devnet'), 'confirmed');
		const key = new PublicKey(
			'AmLHxnyrJBMnYWVzezw1kpoXQ6JQgfrB1kbBDCacwGFn'
		);
		const acc = await connection.getAccountInfo(key);
		const balance = acc.lamports;
		setBal(balance);
		console.log(acc);
	};
	return (
		<div className="App">
			{/* <nav className="App-header">
				<h1>Ovet - Power to the people</h1>
				<input type="text" placeholder="pubkey" />
				<button onClick={() => getBal()}>Demo Run</button>
				<p>
					Balance : <span id="id">{bal}</span>
				</p>
			</nav> */}

			<BrowserRouter>
				<Header />
				<Routes>
					<Route path="/" element={<LandingPage />} />
					<Route path="/dashboard" element={<VotingPage />} />
					<Route path="/about" element={<AboutPage />} />
				</Routes>
				<Footer />
			</BrowserRouter>
		</div>
	);
}

export default App;
